import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import HomePage from '../screens/home/HomePage';
import FindAPet from '../screens/find-a-pet/FindAPet';
import GetPet from "../screens/get-a-pet/GetPet";
import GridListView from '../screens/grid-view/GridListView';
import PetPreferenceDetails from "../screens/preference-details/PetPreferenceDetails";
import SignUp from '../screens/sign-up';
import SignIn from '../screens/sign-in';
import PetBorrower from '../screens/pet-borrower';
import BorrowerInfo from '../screens/borrower-info';
import PetOwner from '../screens/pet-owner-profile'
import ViewPet from '../screens/view-pet';
import AddPet from '../screens/add-pet';

const MainRouter = (route_props) => (
    <Router>
        <Route exact path='/' render={(props) => <HomePage {...props} {...route_props} />} />
        <Route path='/find-a-pet' render={(props) => <FindAPet {...props} {...route_props} />} />
        <Route path='/grid-view' render={(props) => <GridListView {...props} {...route_props} />} />
        <Route path='/get-pets' render={(props) => <GetPet {...props} {...route_props} />} />
        <Route path='/login' render={(props) => <GetPet {...props} {...route_props} />} />
        <Route path='/sign-up' render={(props) => <SignUp {...props} {...route_props} />} />
        <Route path='/sign-in' render={(props) => <SignIn {...props} {...route_props} />} />
        <Route path='/pet-preference' render={(props) => <PetPreferenceDetails {...props} {...route_props} />} />
        <Route path='/pet-borrower' render={(props) => <PetBorrower {...props} {...route_props} />} />
        <Route path='/borrower-info' render={(props) => <BorrowerInfo {...props} {...route_props} />} />
        <Route path='/pet-owner' render={(props) => <PetOwner {...props} {...route_props} />} />
        <Route path='/view-pet' render={(props) => <ViewPet {...props} {...route_props} />} />
        <Route path='/add-pet' render={(props) => <AddPet {...props} {...route_props} />} />
    </Router>
);

export default MainRouter;
